import { useState, useEffect } from "react";
import { useGetAllChannelQuery } from 'src/services/ChannelServices';

const useChannel = () => {
    const [Channel, setChannel] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllChannelQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setChannel(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { Channel, isDataLoading };
};

export default useChannel;
